export default "__VITE_ASSET__9b7826c9__"